query imageContentList($id: [Int]) {
  imageContentList(id: $id) {
    id
    compressedImage {
      webp {
        xs
        sm
        md
        lg
        xl
      }
    }
  }
}
